module.exports = __webpack_public_path__ + "static/media/correct.f8e39478.svg";